import React from 'react';
import $ from 'jquery';
import Containers from '../../utils/containerutil.js';
import { Container, ContainerArrowButton, StateSelector, ToggleSwitch } from '../components.js';

class WhereUsers extends React.Component {

	constructor(props) {
		super(props);

		this.getZipData = this.getZipData.bind(this);
		this.subviewClick = this.subviewClick.bind(this);
		this.contentBuilder = this.contentBuilder.bind(this);
		this.onLeftClick = this.onLeftClick.bind(this);
		this.onRightClick = this.onRightClick.bind(this);
		this.onActiveChange = this.onActiveChange.bind(this);

		this.toggleUpdate = false;
		this.state = { zip : {data :{}, dataError: false},
					 selState : 'MI', stateIndex : 0, showingInactive: true };
	}

	componentDidMount() {
		
		if(this.state.zip.data !== null && Object.keys(this.state.zip.data).length === 0 && this.state.zip.dataError === false) {
			this.getZipData();
		}
	}

	getGreatest(countyData) {
		var greatestState = 'MI', greatestCount = 0, index=0, greatestIndex = 0;

		var sumState = function(stateData) {
			var sum = 0;
			for(var county in stateData) {
				sum += stateData[county].count;
			}

			return sum;
		}

		for(var state in countyData) {
			const stateSum = sumState(countyData[state]);

			if(stateSum > greatestCount) {
				greatestState = state;
				greatestCount = stateSum;
				greatestIndex = index;
			}
			index++;
		}

		return {state : greatestState, index : greatestIndex};
	}

	getZipData() {
		var component = this;

		var callback = function(response) {
			component.toggleUpdate = false;

			if(response.detail !== "Report generated") {
				component.setState({zip : {data: response.data, dataError : response.detail}});
			}
			else {
				for(var i = 0; i !== response.data.zipData.length; i++) {
					var perc = response.data.zipData[i].percentage.toString();
					response.data.zipData[i].percentage = perc.slice(0, (perc.indexOf(".") + 3)) + '%';
				}

				//In keeping with not trusting the input... we will validate it.
				//Remove any states that aren't states that might show up such as "Unknown" etc.

				if(response.data.countyData && Object.keys(response.data.countyData).indexOf('Unknown') > -1) {
					delete response.data.countyData['Unknown'];
				}

				var statesArr = [
					"AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "IA", "ID", "IL",
					"IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", 
					"NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT",
					"VA", "VT", "WA", "WI", "WV", "WY"
				];
				
				for(var sKey in response.data.countyData) {
					if(statesArr.indexOf(sKey) < 0) {
						//console.log("Removing " + sKey);
						delete response.data.countyData[sKey];
					}
				}

				const greatestState = (response.data.countyData) ? component.getGreatest(response.data.countyData) : {state : 'MI', index : 0};
				//console.log(greatestState);
				component.setState({ zip : {data : response.data, dataError: false}, selectedItem : response.data.zipData[0], selState : greatestState.state, stateIndex: greatestState.index });
			}
		};
		
		//console.log('Showing inactive: ' + this.state.showingInactive.toString());
		window._fiSponsor.getZipData(callback, !this.state.showingInactive);
	}

	subviewClick(e) {
		
		if(this.props.subviewClick) this.props.subviewClick(e);
	}

	showStateMap(selState, stateData) {
		//var comp = this;
		////console.log(stateData);
  		var maxCount = 1;
  		for(const zKey in stateData) {
  			maxCount = (parseInt(stateData[zKey].count) > maxCount) ? parseInt(stateData[zKey].count) : maxCount;
  		}
  		
  		const heatColors = [
  			'#c9efff',
  			'#9ce2ff',
  			'#6bd4ff',
  			'#38caff',
  			'#29abe2'
  		];

  		$.getScript(process.env.PUBLIC_URL + "/maps/" + selState + "/mapdata.js", function(data) {
  			
  			$.getScript(process.env.PUBLIC_URL + "/maps/" + selState + "/statemap.js", function(data) {
  				if(typeof simplemaps_statemap_mapdata !== 'undefined' && typeof simplemaps_statemap !== 'undefined') {
  					
	  				for(var i in stateData) {
			  			var countyID = '',
			  				countyData = stateData[i];

			  			////console.log(countyData);
			  			for(const key in window.simplemaps_statemap_mapdata.state_specific) {
			  				var county = window.simplemaps_statemap_mapdata.state_specific[key];
			  				if(county.name.toLowerCase() === countyData.county.toLowerCase() || countyData.county.toLowerCase().indexOf(county.name.toLowerCase()) >= 0) {
			  					
			  					countyID = key;
			  					var existingDesc = window.simplemaps_statemap_mapdata.state_specific[key].description;
			  					var newTotal = (isNaN(parseInt(existingDesc))) ? parseInt(countyData.count) : (parseInt(existingDesc) + parseInt(countyData.count));
			  					window.simplemaps_statemap_mapdata.state_specific[key].description = ': ' + newTotal.toString();
			  					
			  					const totalPerc = newTotal / maxCount;
			  					const factor = 10 / heatColors.length;
			  					var colorIndex = Math.floor(totalPerc / factor * 10 - 1);
			  					
			  					colorIndex = (colorIndex < 0) ? 0 : (colorIndex < heatColors.length) ? colorIndex : heatColors.length - 1;
			  					
			  					window.simplemaps_statemap_mapdata.state_specific[key].color = heatColors[colorIndex];
			  					break;
			  				}
			  			}

			  			if(countyID.length === 0) continue;
			  			else window.simplemaps_statemap_mapdata.data.data[countyID] = countyData.amount;
			  		}

			  		var widthMod = 1.0, tall = true;

			  		switch(selState) {
			  			case "MI":
			  				widthMod = 0.65;
			  				tall = false;
			  				break;
			  			case "CA":
			  				widthMod = 0.42;
			  				break;
			  			case "DE":
			  				widthMod = 0.45;
			  				break;
			  			case "RI":
			  				widthMod = 0.46;
			  				break;
			  			case "NH":
			  				widthMod = 0.47;
			  				break;
			  			case "VT":
			  				widthMod = 0.48;
			  				break;
			  			case "IL":
			  				widthMod = 0.49;
			  				break;
			  			case "IN":
			  				widthMod = 0.5;
			  				break;
			  			case "MS":
			  				widthMod = 0.51;
			  				break;
			  			case "NJ":
			  				widthMod = 0.52;
			  				break;
			  			case "AL":
			  				widthMod = 0.53;
			  				break;
			  			case "ME":
			  				widthMod = 0.54;
			  				break;
			  			case "GA":
			  				widthMod = 0.55;
			  				break;
			  			default:
			  				widthMod = 0.76;
			  				tall = false;
			  				break;
			  		}
			  		var parentWidth = $('#map').parent().innerWidth();
			  		var width = parentWidth * widthMod;
			  		window.simplemaps_statemap_mapdata.main_settings.width = (width).toString();
			  		//window.simplemaps_statemap_mapdata.main_settings.popup_shadow = 0.75;
			  		//window.simplemaps_statemap_mapdata.main_settings.popup_corners = 4;
			  		//window.simplemaps_statemap_mapdata.main_settings.popup_font = "10px/1.5 Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol";
			  		//window.simplemaps_statemap_mapdata.main_settings.label_hover_color = 'blue';
			  		window.simplemaps_statemap_mapdata.main_settings.popup_nocss = 'yes';
			  		window.simplemaps_statemap.load();
			  		$('#map').css('margin', 'auto');
			  		if(tall) $('#map').css('padding-left', ((parentWidth - width) / 3.0).toString() + 'px');
			  		else $('#map').css('padding-left', ((parentWidth - width) / 5).toString() + 'px');

			  		//$('#map_inner').children().last().hide();
		  		}
  			});
		});
	}

	onLeftClick(e) {
		var newIndex = 0;
    var newState = "No State";
    if(this.state.zip.data.countyData) {
      newIndex = (this.state.stateIndex === 0) ? Object.keys(this.state.zip.data.countyData).length - 1 : this.state.stateIndex - 1;
		  newState =  Object.keys(this.state.zip.data.countyData)[newIndex];
    }
		//console.log("Total Keys: " + Object.keys(this.state.zip.data.countyData).length);
		//console.log("Current Index: " + this.state.stateIndex);
		//console.log("Current State: " + Object.keys(this.state.zip.data.countyData)[this.state.stateIndex]);
		//console.log("New Index: " + newIndex);
		//console.log("New State: " + newState);
		this.setState({selState : newState, stateIndex : newIndex})
	}

	onRightClick(e) {;
		var newIndex = 0; 
		var newState =  "No State"; 

    if(this.state.zip.data.countyData) {
      newIndex = (this.state.stateIndex !== Object.keys(this.state.zip.data.countyData).length - 1) ? this.state.stateIndex + 1 : 0;
      newState = Object.keys(this.state.zip.data.countyData)[newIndex];
    }
		//console.log("Total Keys: " + Object.keys(this.state.zip.data.countyData).length);
		//console.log("Current Index: " + this.state.stateIndex);
		//console.log("Current State: " + Object.keys(this.state.zip.data.countyData)[this.state.stateIndex]);
		//console.log("New Index: " + newIndex);
		//console.log("New State: " + newState);
		this.setState({selState : newState, stateIndex : newIndex})
	}

	onActiveChange(e) {
		//console.log("Toggle Change");
		this.toggleUpdate = true;
		this.setState({showingInactive : !this.state.showingInactive})
	}

	contentBuilder() {
		var selectorContent = '';

		if(this.state.zip.data && Object.keys(this.state.zip.data).length) {
			var stateArr = Object.keys(this.state.zip.data.countyData);

			selectorContent = (<StateSelector 
									size={this.props.size} 
									states={stateArr} 
									index={this.state.stateIndex} 
									selected={this.state.zipData} 
									onLeftClick={this.onLeftClick} 
									onRightClick={this.onRightClick} />);
		}

		return (<div className="WhereUsersContent">{selectorContent}<div id="map"></div></div>);
	}

	render() {
		var passedZip = this.state.zip;
		if(this.toggleUpdate === true) {
			this.getZipData();
			passedZip = {data : {}, dataError: false};
		}

		var zipChart;

		const whereContainerSize = {
		  	width : (this.props.size) ? this.props.size.width : '45.5vmin',
		  	height: (this.props.size) ? this.props.size.height : '36vmin'
		};

	  	zipChart = Containers.getContainerDisplay(passedZip, this.contentBuilder);

	  	if(this.state.zip.data && Object.keys(this.state.zip.data).length) {
	  		////console.log(Object.keys(this.state.zip.data.countyData)[0]);

	  		if(this.state.zip.data.countyData && 
          Object.keys(this.state.zip.data.countyData)[0] && 
          Object.keys(this.state.zip.data.countyData)[0].length === 2) {
	  			////console.log('Key equals 2');
	  			////console.log("Selected State is: " + this.state.selState);
	  			this.showStateMap(this.state.selState, this.state.zip.data.countyData[this.state.selState]);
	  		}
	  		else {
	  			this.showStateMap(this.state.selState,  this.state.zip.data.countyData);
	  		}
	  		

	  	}

		const whereHeaderButton = this.props.subview ? (
  			<ContainerArrowButton data-id={'where'} onClick={this.subviewClick} />
  		) : false;

		var toggleContent = (
			<ToggleSwitch
				id="active-switch"
				Name="active-switch"
				Text={["Currently including inactive users", "Only showing active users"]}
				onChange = {this.onActiveChange}
				currentValue = {this.state.showingInactive}
				addClass = "absolute-to-map"
				Small = {true}
			/>

		);

  		return (
  			<Container 
  				key='wayu' 
  				moreClass={'Container-Stackable ' + this.props.heatmap + ' ' + this.props.addClass} 
  				titles={[{'label' : 'Where Are Your Users?', 'onClick' : ''}]} 
  				note={'The darker cyan the county, the more active/inactive Plinqit users live there.'} 
  				contents={zipChart} 
  				button={whereHeaderButton} 
  				size={whereContainerSize} 
  				bgcolor="#48a7e3" 
  				onclick={this.props.onclick} 
  				append = {toggleContent}
  			/>
  		);
	}
}

export default WhereUsers;








